/*=========================================================================================
  File Name: moduleSpace.js
  Description: Space Module
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


import state from './moduleAlarmState.js'
import mutations from './moduleAlarmMutations.js'
import actions from './moduleAlarmActions.js'
import getters from './moduleAlarmGetters.js'

export default {
	namespaced: true,
    state: state,
    mutations: mutations,
    actions: actions,
    getters: getters
}
